export default {
  enabled: true,
  settings: {
    site_id: '',
    access_token: '',
    form_name: ''
  }
}
